module.exports = __webpack_public_path__ + "static/media/29EUNOG6.fbb2fc86.jpg";